import React from "react";

import { Bar } from "./styles";

interface StickyActionBarProps {
    className?: string;
    children: React.ReactNode;
}

export const StickyActionBar = ({ className, children }: StickyActionBarProps) => (
    <Bar className={className}>{children}</Bar>
);
